// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file consts/agreementconsts.proto (package aurora.core.consts.agreements, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file consts/agreementconsts.proto.
 */
export const file_consts_agreementconsts: GenFile = /*@__PURE__*/
  fileDesc("Chxjb25zdHMvYWdyZWVtZW50Y29uc3RzLnByb3RvEh1hdXJvcmEuY29yZS5jb25zdHMuYWdyZWVtZW50cyp0Cg9BZ3JlZW1lbnRTdGF0dXMSIAocQUdSRUVNRU5UX1NUQVRVU19VTlNQRUNJRklFRBAAEgkKBURSQUZUEAESCgoGQUNUSVZFEAISDAoIUkVKRUNURUQQAxIMCghDQU5DRUxFRBAEEgwKCElOQUNUSVZFEAUqVQoQQ29sbGF0ZXJhbE1ldGhvZBIhCh1DT0xMQVRFUkFMX01FVEhPRF9VTlNQRUNJRklFRBAAEgoKBlBMRURHRRABEhIKDlRJVExFX1RSQU5TRkVSEAIqYgoIVGVybVR5cGUSGQoVVEVSTV9UWVBFX1VOU1BFQ0lGSUVEEAASCAoETk9ORRABEgkKBUZJWEVEEAISDQoJRVZFUkdSRUVOEAMSCwoHT05FX0RBWRAEEgoKBkJVTExFVBAFKnsKEFNldHRsZW1lbnRTeXN0ZW0SIQodU0VUVExFTUVOVF9TWVNURU1fVU5TUEVDSUZJRUQQABITCg9QUk9WQUJMRV9NQVJLRVQQARIKCgZMT0FORVQQAhIOCgpMT0FORVRfU0ZUEAMSCQoFU1BJUkUQBBIICgRQUk9QEAUqcAoOQ29sbGF0ZXJhbFR5cGUSHwobQ09MTEFURVJBTF9UWVBFX1VOU1BFQ0lGSUVEEAASCAoEQ0FTSBABEhAKDE5PTl9DQVNIX1VTVBACEg8KC05PTl9DQVNIX0VREAMSEAoMTk9OX0NBU0hfSkdCEAQqPwoMRGVsaXZlcnlUeXBlEh0KGURFTElWRVJZX1RZUEVfVU5TUEVDSUZJRUQQABIHCgNEVlAQARIHCgNGT1AQAkIpWidnaXRsYWIucHJ2YmwuY29tL2F1cm9yYS9jb3JlL3NyYy9jb25zdHNiBnByb3RvMw");

/**
 * possible agreement status
 *
 * @generated from enum aurora.core.consts.agreements.AgreementStatus
 */
export enum AgreementStatus {
  /**
   * @generated from enum value: AGREEMENT_STATUS_UNSPECIFIED = 0;
   */
  AGREEMENT_STATUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: DRAFT = 1;
   */
  DRAFT = 1,

  /**
   * @generated from enum value: ACTIVE = 2;
   */
  ACTIVE = 2,

  /**
   * @generated from enum value: REJECTED = 3;
   */
  REJECTED = 3,

  /**
   * @generated from enum value: CANCELED = 4;
   */
  CANCELED = 4,

  /**
   * @generated from enum value: INACTIVE = 5;
   */
  INACTIVE = 5,
}

/**
 * Describes the enum aurora.core.consts.agreements.AgreementStatus.
 */
export const AgreementStatusSchema: GenEnum<AgreementStatus> = /*@__PURE__*/
  enumDesc(file_consts_agreementconsts, 0);

/**
 * @generated from enum aurora.core.consts.agreements.CollateralMethod
 */
export enum CollateralMethod {
  /**
   * @generated from enum value: COLLATERAL_METHOD_UNSPECIFIED = 0;
   */
  COLLATERAL_METHOD_UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLEDGE = 1;
   */
  PLEDGE = 1,

  /**
   * @generated from enum value: TITLE_TRANSFER = 2;
   */
  TITLE_TRANSFER = 2,
}

/**
 * Describes the enum aurora.core.consts.agreements.CollateralMethod.
 */
export const CollateralMethodSchema: GenEnum<CollateralMethod> = /*@__PURE__*/
  enumDesc(file_consts_agreementconsts, 1);

/**
 * @generated from enum aurora.core.consts.agreements.TermType
 */
export enum TermType {
  /**
   * @generated from enum value: TERM_TYPE_UNSPECIFIED = 0;
   */
  TERM_TYPE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: NONE = 1;
   */
  NONE = 1,

  /**
   * @generated from enum value: FIXED = 2;
   */
  FIXED = 2,

  /**
   * @generated from enum value: EVERGREEN = 3;
   */
  EVERGREEN = 3,

  /**
   * @generated from enum value: ONE_DAY = 4;
   */
  ONE_DAY = 4,

  /**
   * @generated from enum value: BULLET = 5;
   */
  BULLET = 5,
}

/**
 * Describes the enum aurora.core.consts.agreements.TermType.
 */
export const TermTypeSchema: GenEnum<TermType> = /*@__PURE__*/
  enumDesc(file_consts_agreementconsts, 2);

/**
 * @generated from enum aurora.core.consts.agreements.SettlementSystem
 */
export enum SettlementSystem {
  /**
   * @generated from enum value: SETTLEMENT_SYSTEM_UNSPECIFIED = 0;
   */
  SETTLEMENT_SYSTEM_UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROVABLE_MARKET = 1;
   */
  PROVABLE_MARKET = 1,

  /**
   * @generated from enum value: LOANET = 2;
   */
  LOANET = 2,

  /**
   * @generated from enum value: LOANET_SFT = 3;
   */
  LOANET_SFT = 3,

  /**
   * @generated from enum value: SPIRE = 4;
   */
  SPIRE = 4,

  /**
   * @generated from enum value: PROP = 5;
   */
  PROP = 5,
}

/**
 * Describes the enum aurora.core.consts.agreements.SettlementSystem.
 */
export const SettlementSystemSchema: GenEnum<SettlementSystem> = /*@__PURE__*/
  enumDesc(file_consts_agreementconsts, 3);

/**
 * @generated from enum aurora.core.consts.agreements.CollateralType
 */
export enum CollateralType {
  /**
   * @generated from enum value: COLLATERAL_TYPE_UNSPECIFIED = 0;
   */
  COLLATERAL_TYPE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: CASH = 1;
   */
  CASH = 1,

  /**
   * @generated from enum value: NON_CASH_UST = 2;
   */
  NON_CASH_UST = 2,

  /**
   * @generated from enum value: NON_CASH_EQ = 3;
   */
  NON_CASH_EQ = 3,

  /**
   * @generated from enum value: NON_CASH_JGB = 4;
   */
  NON_CASH_JGB = 4,
}

/**
 * Describes the enum aurora.core.consts.agreements.CollateralType.
 */
export const CollateralTypeSchema: GenEnum<CollateralType> = /*@__PURE__*/
  enumDesc(file_consts_agreementconsts, 4);

/**
 * @generated from enum aurora.core.consts.agreements.DeliveryType
 */
export enum DeliveryType {
  /**
   * @generated from enum value: DELIVERY_TYPE_UNSPECIFIED = 0;
   */
  DELIVERY_TYPE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: DVP = 1;
   */
  DVP = 1,

  /**
   * @generated from enum value: FOP = 2;
   */
  FOP = 2,
}

/**
 * Describes the enum aurora.core.consts.agreements.DeliveryType.
 */
export const DeliveryTypeSchema: GenEnum<DeliveryType> = /*@__PURE__*/
  enumDesc(file_consts_agreementconsts, 5);

